/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ruler_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why do I need to calibrate?`)
};

const es_ruler_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué necesito calibrar?`)
};

const de_ruler_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum muss ich kalibrieren?`)
};

const nl_ruler_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom moet ik kalibreren?`)
};

const fr_ruler_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi dois-je calibrer ?`)
};

const it_ruler_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché devo calibrare?`)
};

const pt_br2_ruler_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que preciso calibrar?`)
};

const pt_ruler_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque preciso de calibrar?`)
};

const ja_ruler_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜ校正が必要なのですか?`)
};

const zh_ruler_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么需要校准？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ruler_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ruler_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ruler_faq_q1", locale)
	if (locale === "en") return en_ruler_faq_q1(inputs)
	if (locale === "es") return es_ruler_faq_q1(inputs)
	if (locale === "de") return de_ruler_faq_q1(inputs)
	if (locale === "nl") return nl_ruler_faq_q1(inputs)
	if (locale === "fr") return fr_ruler_faq_q1(inputs)
	if (locale === "it") return it_ruler_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_ruler_faq_q1(inputs)
	if (locale === "pt") return pt_ruler_faq_q1(inputs)
	if (locale === "ja") return ja_ruler_faq_q1(inputs)
	return zh_ruler_faq_q1(inputs)
};